import React from 'react';
import styled from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import { plainTextStyle } from '@westwing/ui-kit/typography';
import { Color } from '../GlobalStyles/theme';
import useBellaTranslator from '../../hooks/useTranslator';

const Badge = styled.div<{ color?: Color }>`
    ${plainTextStyle}
    height: 19px;
    display: inline;
    color: ${({ color, theme }) => theme.colors[color || 'charcoal100']};
    border: 1px solid ${({ color, theme }) => theme.colors[color || 'charcoal100']};
    font-size: 11px;
    ${forTablet`
        font-size: 12px;
    `}
    line-height: 13px;
    letter-spacing: 1.39;
    text-transform: uppercase;
    background: ${({ theme }) => theme.colors.charcoal3};
    padding: 2px 6px;
`;

export const SoldOutBadge = () => {
    const t = useBellaTranslator();
    return <Badge color="charcoal100">{t('Sold Out Badge')}</Badge>;
};

export const SUSTAINABILITY_LABEL = 'Sustainability_Label';

export const SustainabilityBadge = ({ className }: { className?: string }) => {
    const t = useBellaTranslator();
    return (
        <Badge data-testid="sustainability-badge" color="turquoise100" className={className}>
            {t(SUSTAINABILITY_LABEL)}
        </Badge>
    );
};
